import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Link } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { Icon } from '@grandvisionhq/icons';
import BillingAddressContainer from '../Profile/components/BillingAddress/BillingAddressContainer.js';
import PersonalDetailsContainer from '../Profile/components/PersonalDetails/PersonalDetailsContainer.js';

const Settings = ({ intl , showOptInsLink , showPasswordLink , className  })=>{
    const changePasswordLinkAttributes = useLink({
        route: 'auth.change-password'
    });
    const communicationsLinkAttributes = useLink({
        route: 'me.settings.comms'
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('settings', className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, intl.getLabel('account.menu.settings')), /*#__PURE__*/ React.createElement(Text, null, intl.getLabel('account.settings.intro')), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, intl.getLabel('account.profile.personalDetails')), /*#__PURE__*/ React.createElement(PersonalDetailsContainer, {
        showEditButton: true
    })), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, intl.getLabel('account.billingAddress')), /*#__PURE__*/ React.createElement(BillingAddressContainer, {
        showEditButton: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: "settings__account-details"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, intl.getLabel('account.settings.accountDetails')), /*#__PURE__*/ React.createElement(React.Fragment, null, showPasswordLink && /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, changePasswordLinkAttributes), intl.getLabel('account.changePassword'), /*#__PURE__*/ React.createElement(Icon, {
        className: "settings__account-details__icon",
        name: "chevron-right"
    })), showOptInsLink && /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, communicationsLinkAttributes), intl.getLabel('account.settings.communicationPreferences'), /*#__PURE__*/ React.createElement(Icon, {
        className: "settings__account-details__icon",
        name: "chevron-right"
    })))));
};

export { Settings };
//# sourceMappingURL=Settings.js.map
